<form [formGroup]="feeGroupForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{ type }} Fee Group
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">
        <!-- Group Name -->
        <div class="field">
            <label class="requiredValue">Group Name</label>
            <input pInputText formControlName="group_name" placeholder="Enter Fee Group Name" />
            <small *ngIf="feeGroupForm.get('group_name')?.invalid && isSubmitted" class="p-error">
                Group Name is required
            </small>
        </div>

        <!-- Description -->
        <div class="field">
            <label>Description</label>
            <textarea pTextarea formControlName="description" placeholder="Enter Description"></textarea>
        </div>

        <!-- Applicable To -->
        <div class="field">
            <label>Applicable To</label>
            <p-select 
             appendTo="body"
            formControlName="applicable_to" [options]="applicableOptions"
                placeholder="Select Applicable"></p-select>
        </div>

        <!-- Academic Year & Department -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Academic Year</label>
                <p-select 
                 appendTo="body"
                formControlName="academic_year_id" [options]="allAcademicYears" optionLabel="label"
                    optionValue="value" placeholder="Select Academic Year"></p-select>
                <small *ngIf="feeGroupForm.get('academic_year_id')?.invalid && isSubmitted" class="p-error">
                    Academic Year is required
                </small>
            </div>

            <div class="field">
                <label>Course</label>
                <p-select 
                 appendTo="body"
                formControlName="course_id" [options]="allCourses" optionLabel="label" optionValue="value"
                    placeholder="Select Course"></p-select>
            </div>

            <!-- <div class="field">
        <label>Department</label>
        <p-select formControlName="department_id" [options]="departmentOptions" optionLabel="label"
          optionValue="value" placeholder="Select Department"></p-select>
      </div> -->
        </div>

        <!-- Course -->


        <!-- Total Fees & Currency -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Total Fees</label>
                <input pInputText type="number" formControlName="total_fees" placeholder="Enter Total Fees" />
                <small *ngIf="feeGroupForm.get('total_fees')?.invalid && isSubmitted" class="p-error">
                    Total Fees is required
                </small>
            </div>

            <div class="field">
                <label>Currency</label>
                <p-select
                 appendTo="body"
                formControlName="currency" [options]="currencyOptions" placeholder="Select Currency"></p-select>
            </div>
        </div>

        <!-- Active Status -->
        <div class="field">
            <label>Status</label>
            <p-select
            appendTo="body"
            [options]="statusOptions" formControlName="is_active" placeholder="Select Status"></p-select>
        </div>

        <!-- Action buttons -->
        <div class="flex justify-end gap-2 mt-8">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                (click)="onSubmit()"></p-button>
        </div>
    </div>
</form>